/*eslint-disable*/module.exports={messages:{"Alc.: {0}%":["Alc.: ",["0"],"%"]}};